import axios, { AxiosInstance } from "axios";
import { API_URL } from "../../utils/globals";
import { GetTransactionByOrderId } from "../models/GetTransactionByOrderId";

class TransactionService {
  private api: AxiosInstance;

  constructor() {
    this.api = axios.create({
      baseURL: API_URL,
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  public async getTransactionByOrderId(
    orderId: string,
  ): Promise<GetTransactionByOrderId> {
    const response = await this.api.get<GetTransactionByOrderId>(
      "/transactions/getPayinTransactionByOrderId",
      {
        params: {
          orderId,
        },
      },
    );
    return response.data;
  }
}

export const transactionService = new TransactionService();
